export enum PasswordToggle {
  Old = 0,
  New = 1,
  Repeat = 2
}
